module.exports = __webpack_public_path__ + "static/media/taffiethule14.c640fe4f.jpg";